var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 7,
    viewBox: "0 0 9 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.08565 3.03148C1.82689 2.70803 1.35493 2.65559 1.03148 2.91435C0.708032 3.17311 0.655591 3.64507 0.914348 3.96852L2.08565 3.03148ZM3.5 6L2.91435 6.46852C3.04762 6.63511 3.24552 6.73705 3.45852 6.74885C3.67153 6.76065 3.87948 6.68118 4.03033 6.53033L3.5 6ZM8.53033 2.03033C8.82322 1.73744 8.82322 1.26256 8.53033 0.96967C8.23744 0.676777 7.76256 0.676777 7.46967 0.96967L8.53033 2.03033ZM0.914348 3.96852L2.91435 6.46852L4.08565 5.53148L2.08565 3.03148L0.914348 3.96852ZM4.03033 6.53033L8.53033 2.03033L7.46967 0.96967L2.96967 5.46967L4.03033 6.53033Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCheckbox);
export default __webpack_public_path__ + "static/media/check-checkbox.b287d2e8.svg";
export { ForwardRef as ReactComponent };